export class AcordarUtils {
	static paramExistInParams(filtername, params) {
		let response = false;
		params.map((param) => {
			if (param.nombre === filtername) {
				response = true;
			}
		});
		return response;
	}

	static orderAlphabetically(a, b) {
		if (a < b) {
			return -1;
		}
		if (b < a) {
			return 1;
		}
		return 0;
	}

	static evaluate(paramName, response, params) {
		console.log(params, paramName, response);
		if (response == '' || response == null || response === 'empty') {
			let indexToErase;
			params.map((param, index) => {
				if (param.nombre === paramName) {
					indexToErase = index;
				}
			});
			params.splice(indexToErase, 1);
			return params;
		} else if (AcordarUtils.paramExistInParams(paramName, params) === true) {
			params.map((param) => {
				if (param.nombre === paramName) {
					param.value = response;
				}
			});
		} else {
			params.push({ nombre: paramName, value: response });
		}
		console.log(params, paramName, response);

		return params;
	}

	static capitalizeLetter(str) {
		if (str !== 'CABA') {
			return str
				.toLowerCase()
				.split(' ')
				.map(function(word) {
					if (word[0]) {
						return word[0].toUpperCase() + word.substr(1);
					} else {
						return ""
					}
				})
				.join(' ');
		} else {
			return str;
		}
	}

	static createPaginationArray(pagination) {
		let responseArr = [];
		for (let i = 1; i < pagination + 1; i++) {
			responseArr.push(i);
		}
		return responseArr;
	}

	static selectProv(prov, idProvincia) {
		let response;
		if (prov === idProvincia) {
			response = true;
		} else if (idProvincia === null) {
			response = null;
		} else {
			response = false;
		}
		return response;
	}

	static mapProv(p, provs) {
		let response = p;
		provs.map((prov) => {
			if (prov.gidBack === p) {
				return (response = prov.gid);
			}
		});
		return response;
	}
}
